import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchProjectCommits = () => {
  const [commitData, setCommitData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCommitData = async () => {
      try {
        const response = await axios.get('/api/Audit/project-commits');
        const data = response.data;

        if (!Array.isArray(data)) {
          throw new Error('Unexpected API response format');
        }

        const processedData = processCommitData(data);
        setCommitData(processedData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCommitData();
  }, []);

  return { commitData, loading, error };
};

const processCommitData = (data) => {
  if (!Array.isArray(data)) {
    return {};
  }

  const result = {};
  const allNames = new Set(data.map(({ name }) => name));

  allNames.forEach((name) => {
    result[name] = { Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 };
  });

  data.forEach(({ name, lastModifiedDay, commits }) => {
    if (!name || !lastModifiedDay || typeof commits !== 'number') return;

    const dayMap = {
      Sunday: 'Sun',
      Monday: 'Mon',
      Tuesday: 'Tue',
      Wednesday: 'Wed',
      Thursday: 'Thu',
      Friday: 'Fri',
      Saturday: 'Sat',
    };

    const dayName = dayMap[lastModifiedDay] || null;

    if (dayName) {
      result[name][dayName] = commits;
    }
  });

  return result;
};

export default useFetchProjectCommits;
